const { getStockPlateformFeeImpact } = require('@balibart/stocks')

const logger = process.env.TEST ? {} : console

const getProductPrice = (product, baseProduct, variations_selected, noMargin, stocks) => {
  try {
    let price = parseFloat(baseProduct.unitPrice) +
            (noMargin ? 0 : parseFloat(product.pricing.margin || 0)) +
            parseFloat(product.pricing.customizationPrice || 0)
    if (variations_selected) {
      const bp_vars = baseProduct.variations ?
        baseProduct.variations.filter((va) => Object.values(variations_selected)
          .find((va_) => va_.reference === va.reference && va_.type === va.type)) :
        []
      price = price +
      bp_vars.map((va) => parseFloat(va.priceImpact) || 0).reduce((acc, curr) => acc + curr, 0)
    }
    if (noMargin) {
      const plateformFeeImpact = getStockPlateformFeeImpact(product, stocks)
      price = price + (plateformFeeImpact || 0)
    }
    price = parseFloat(price).toFixed(2)
    return (price % 1 === 0) ? parseInt(price, 10) : price
  } catch (error) {
    logger.log({
      error,
      level: 'err',
      message: 'getPrice',
      variations_selected,
      product,
      baseProduct,
    })
    return false
  }
}

const calculateCartPrice = (cart, products, noMargin, stocks) => {
  if (!cart) throw new Error('no cart')
  if (!cart.products.length) throw new Error('no products')
  const cartPrice = cart.products.map((product) => {    
    const stocksProduct = stocks.find(stock => stock.productId === String(product._id) 
    || stock.productId === String(product.id))

    const canonicalProduct = products.find(p => p._id === product._id)
    return parseFloat(getProductPrice(
      canonicalProduct,
      canonicalProduct.baseProduct,
      product.variations,
      noMargin,
      stocksProduct,
    )) * product.quantity
  }).reduce((acc, curr) => acc + curr, 0)
  return cartPrice
}


module.exports = {
  calculateCartPrice,
  getProductPrice,
}
